import { useNavigate, useLocation } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";

interface LegalModalProps {
  title: string;
  children: React.ReactNode;
}

export const LegalModal = ({ title, children }: LegalModalProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const isOpen = ["/terms", "/privacy", "/cookies", "/gdpr"].includes(location.pathname);

  const handleClose = () => {
    navigate("/");
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && handleClose()}>
      <DialogContent className="max-w-3xl max-h-[85vh]">
        <DialogHeader>
          <DialogTitle className="font-clash text-3xl font-bold tracking-tight">{title}</DialogTitle>
        </DialogHeader>
        <ScrollArea className="h-[calc(85vh-8rem)] pr-4">
          <div className="prose prose-sm dark:prose-invert max-w-none">
            {children}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
